import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Behance, Dribbble, Facebook, Instagram, Linkedin, Medium, Twitter, Youtube } from "@styled-icons/boxicons-logos";
import React from "react";
import { SavvycomLogo } from "../Svg";
import { FooterRoot } from "./styles";
var socialList = [
    {
        icon: /*#__PURE__*/ _jsx(Linkedin, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "LinkedIn"
    },
    {
        icon: /*#__PURE__*/ _jsx(Medium, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "Medium"
    },
    {
        icon: /*#__PURE__*/ _jsx(Facebook, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "Facebook"
    },
    {
        icon: /*#__PURE__*/ _jsx(Twitter, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "Twitter"
    },
    {
        icon: /*#__PURE__*/ _jsx(Instagram, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "Instagram"
    },
    {
        icon: /*#__PURE__*/ _jsx(Youtube, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "Youtube"
    },
    {
        icon: /*#__PURE__*/ _jsx(Behance, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "Behance"
    },
    {
        icon: /*#__PURE__*/ _jsx(Dribbble, {
            size: 18,
            color: "#ffffffa5"
        }),
        href: "",
        title: "Dribbble"
    }, 
];
var MenuItem = function() {
    return /*#__PURE__*/ _jsxs(FooterRoot, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "logo",
                children: /*#__PURE__*/ _jsx(SavvycomLogo, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "description",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "SAVVY is an ecosystem of innovative products made with blockchain and AI technologies."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "p2",
                        children: "Savvydex is a demonstration (i.e., solely for non-commercial purposes to learn more about our blockchain technologies and services) of being developed multi-chain technologies for Trading, Farming, Staking, etc., cryptocurrencies in a flexible and efficient way."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "social",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "social-content",
                    children: socialList.map(function(item, index) {
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "social-item",
                            children: [
                                item.icon,
                                item.title
                            ]
                        }, "social-".concat(item.title));
                    })
                })
            })
        ]
    });
};
export default MenuItem;
